import i18next from 'i18next';
import React from 'react';

import { EXTERNAL_FEATURE_PATHS } from '@commons/utils/featurePaths';
import { formatDateWithLanguageCode } from '@commons/utils/date';
import { Tags } from '@commons/Tags';
import Text, { ENUM_COLORS, ENUM_FONTS } from '@commons/Text';

import { externalClient as externalClientService } from '@services/externalClient';

import NextOrders from '../components/NextOrders';
import ProductCountBadge from '../components/ProductCountBadge';

const getUpcomingOrderLink = ({ id }) =>
  EXTERNAL_FEATURE_PATHS.EXTERNAL_ORDERS_DETAILS.replace(':id', id);

const getUpcomingOrdersColumns = (userLanguageCode) => [
  {
    id: 'reference',
    propertyKey: 'reference',
    render: (reference) => (
      <Text color={ENUM_COLORS.DARKEST} font={ENUM_FONTS.TEXT_SMALL_HEIGHT_14_WEIGHT_700_BOLD}>
        {reference}
      </Text>
    ),
  },
  {
    id: 'deliveryDate',
    propertyKey: 'deliveryDate',
    render: (deliveryDate) => (
      <Text color={ENUM_COLORS.DARKER} font={ENUM_FONTS.TEXT_SMALL_HEIGHT_16}>
        {formatDateWithLanguageCode(deliveryDate, userLanguageCode)}
      </Text>
    ),
  },
];

export const getColumns = ({ userLanguageCode }) => [
  {
    id: 'name',
    propertyKey: 'name',
    name: i18next.t('EXTERNAL_CLIENTS.LIST.COLUMN_CLIENT'),
    render: (name) => (
      <Text color={ENUM_COLORS.DARKEST} font={ENUM_FONTS.TEXT_BIG_HEIGHT_16}>
        {name}
      </Text>
    ),
  },
  {
    id: 'externalReference',
    propertyKey: 'externalReference',
    name: i18next.t('EXTERNAL_CLIENTS.LIST.COLUMN_EXTERNAL_REFERENCE'),
    disableSort: true,
    render: (externalReference) => (
      <Text color={ENUM_COLORS.DARKEST} font={ENUM_FONTS.TEXT_BIG_HEIGHT_16}>
        {externalReference || '-'}
      </Text>
    ),
  },
  {
    id: 'stores',
    propertyKey: 'stores',
    name: i18next.t('EXTERNAL_CLIENTS.LIST.COLUMN_STORES'),
    disableSort: true,
    render: (stores) => <Tags items={(stores ?? []).map(({ name }) => name)} />,
  },
  {
    id: 'productCount',
    propertyKey: 'productCount',
    name: i18next.t('EXTERNAL_CLIENTS.LIST.COLUMN_PRODUCT_COUNT'),
    tooltipText: i18next.t('EXTERNAL_CLIENTS.LIST.PRODUCT_COUNT_TOOLTIP'),
    render: (productCount) => <ProductCountBadge productCount={productCount} />,
  },
  {
    id: 'upcomingOrders',
    propertyKey: 'upcomingOrders',
    name: i18next.t('EXTERNAL_CLIENTS.LIST.COLUMN_UPCOMING_ORDERS'),
    disableSort: true,
    tooltipText: i18next.t('EXTERNAL_CLIENTS.LIST.UPCOMING_ORDERS_TOOLTIP'),
    render: (upcomingOrders, externalClient) => (
      <NextOrders
        columns={getUpcomingOrdersColumns(userLanguageCode)}
        emptyStateLabel={i18next.t('EXTERNAL_CLIENTS.LIST.UPCOMING_ORDERS_EMPTY')}
        getOrderLink={getUpcomingOrderLink}
        loadOrders={() => externalClientService.getUpcomingOrders(externalClient.id)}
        title={i18next.t('EXTERNAL_CLIENTS.LIST.COLUMN_UPCOMING_ORDERS')}
      />
    ),
  },
];
